import React, { useRef, useState } from "react";
import "./OtpInput.css";

interface OtpInputProps {
    length?: number; // default 4
    onChange: (otp: string) => void;
    error?: boolean;
    isLoading: boolean;
}

const OtpInput: React.FC<OtpInputProps> = ({ length = 4, onChange, error, isLoading }) => {
    const [otpValues, setOtpValues] = useState<string[]>(Array(length).fill(""));
    const inputRefs = useRef<Array<HTMLInputElement | null>>([]);

    const handleChange = (index: number, value: string) => {
        if (!/^\d*$/.test(value)) return; // allow only digits
        const newOtp = [...otpValues];
        newOtp[index] = value;
        setOtpValues(newOtp);
        onChange(newOtp.join(""));

        // Move to next input if digit entered
        if (value && index < length - 1) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Backspace" && !otpValues[index] && index > 0) {
            inputRefs.current[index - 1]?.focus();
        }
    };

    const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
        e.preventDefault();
        const pasted = e.clipboardData.getData("text").slice(0, length);
        if (!/^\d+$/.test(pasted)) return;

        const newOtp = pasted.split("");
        setOtpValues(newOtp);
        onChange(newOtp.join(""));
        inputRefs.current[length - 1]?.focus();
    };

    return (
        <div className={`otp-container ${error ? "error-field" : ""}`}>
            {otpValues.map((val, idx) => (
                <input
                    disabled={isLoading}
                    key={idx}
                    type="text"
                    maxLength={1}
                    value={val}
                    onChange={(e) => handleChange(idx, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(idx, e)}
                    onPaste={handlePaste}
                    ref={(el) => {
                        inputRefs.current[idx] = el;
                    }}
                    className="otp-input"
                />
            ))}
        </div>
    );
};

export default OtpInput;
